import { apiClient } from '@/sdk/shared/apiClient';
import type {
  FullProfileResponse,
  UpdateProfileRequest,
  UpdateProfileResponse,
  ChangePasswordRequest,
  ChangePasswordResponse
} from './types';

export const clientProfileApi = {
  // Fetch full client profile details
  getProfile: async (): Promise<FullProfileResponse> => {
    return await apiClient.get<FullProfileResponse>('/client/profile');
  },

  // Update client profile details
  updateProfile: async (data: UpdateProfileRequest | FormData): Promise<UpdateProfileResponse> => {
    return await apiClient.put<UpdateProfileResponse>('/client/profile', data);
  },

  // Upload client profile photo
  uploadProfilePhoto: async (formData: FormData): Promise<UpdateProfileResponse> => {
    return await apiClient.post<UpdateProfileResponse>('/client/profile/photo', formData);
  },

  // Change client password
  changePassword: async (data: ChangePasswordRequest): Promise<ChangePasswordResponse> => {
    return await apiClient.put<ChangePasswordResponse>('/client/profile/password', data);
  }
};

export default clientProfileApi;
